import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { HdfsCopySource } from 'app/model/pipeline/copysource/hdfs.copysource';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FileTypeSourceAdapter } from 'app/model/adapters/activities/copysource/file-type.source.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HdfsCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        recursive: '*',
        distcpSettings: '*',
        maxConcurrentConnections: '*'
    }
})
export class HdfsCopySourceAdapter extends CopySourceAdapter<HdfsCopySource, Model.HdfsSource> {
    protected override async _toResource(copySource: HdfsCopySource): Promise<Model.HdfsSource> {
        const result: Model.HdfsSource = this.getCommonCopySourceProperties(copySource, 'HdfsSource');
        FileTypeSourceAdapter.toSourceResource(copySource, result);
        if (copySource.useDistCp) {
            result.distcpSettings = {
                resourceManagerEndpoint: ValueAdapter.toResource(copySource, HdfsCopySource.RESOURCE_MANAGER_ENDPOINT),
                tempScriptPath: ValueAdapter.toResource(copySource, HdfsCopySource.TEMP_SCRIPT_PATH),
                distcpOptions: ValueAdapter.toResource(copySource, HdfsCopySource.DIST_CP_OPTIONS)
            };
        }
        return result;
    }

    protected override async _toModel(
        hdfsSource: Model.HdfsSource,
        copyActivity: CopyActivity
    ): Promise<HdfsCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            HdfsCopySource.MODEL,
            hdfsSource,
            copyActivity
        ) as HdfsCopySource;
        FileTypeSourceAdapter.toSourceModel(hdfsSource, result);
        if (hdfsSource.distcpSettings) {
            result.useDistCp = true;
            ValueAdapter.toModel(
                result,
                HdfsCopySource.RESOURCE_MANAGER_ENDPOINT,
                hdfsSource.distcpSettings.resourceManagerEndpoint
            );
            ValueAdapter.toModel(result, HdfsCopySource.TEMP_SCRIPT_PATH, hdfsSource.distcpSettings.tempScriptPath);
            ValueAdapter.toModel(result, HdfsCopySource.DIST_CP_OPTIONS, hdfsSource.distcpSettings.distcpOptions);
        }
        return result;
    }
}
